import React, { Component } from 'react'
import { throttleTime } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import BackToTopButton from '@components/back-to-top-button'
import SearchButton from 'components/SearchButton'
import { TOPBANNER_HEIGHT_SCREEN_LARGE } from 'constants/parallaxEffects'
import {
  isCatalogOrUniversePagePath,
  isProductPagePath
} from 'domain/router'
import { scrollObservable$ } from '../../DOMEvents'
import withConnect from './connector'
import { Wrapper } from './style'
import {
  DisplayWidgetOnScroll,
  IsCatalogOrProductPage,
  Props,
  ScrollToTop,
  State
} from './types'

class FixedWidget extends Component<Props, State> {
  state = { displayFromScroll: false }
  scrollObservable: Subscription | undefined

  componentDidMount (): void {
    this.scrollObservable = scrollObservable$
      .pipe(throttleTime(50))
      .subscribe(this.displayWidgetOnScroll)
  }

  componentWillUnmount (): void {
    if (this.scrollObservable) { this.scrollObservable.unsubscribe() }
  }

  scrollToTop: ScrollToTop = () => { window.scrollTo(0, 0) }

  get offset (): number {
    const { screenSize: { large } } = this.props

    if (large) { return TOPBANNER_HEIGHT_SCREEN_LARGE }
    return (document.getElementsByClassName('catalogContent')[0]?.getBoundingClientRect()?.height ?? 0) - window.innerHeight
  }

  displayWidgetOnScroll: DisplayWidgetOnScroll = () => {
    if (document.getElementsByClassName('catalogContent')[0]) {
      const displayFromScroll = window.scrollY > this.offset

      if (displayFromScroll !== this.state.displayFromScroll) {
        this.setState({ displayFromScroll })
      }
    }
  }

  isEnabled: IsCatalogOrProductPage = () => {
    const { pathname, screenSize } = this.props

    return isCatalogOrUniversePagePath(pathname) || (isProductPagePath(pathname) && screenSize.large)
  }

  render (): React.ReactNode {
    const { p, screenSize } = this.props

    if (!this.isEnabled()) {
      return null
    }

    return (
      <Wrapper
        data-test-id='arrowScroll'
        visible={this.state.displayFromScroll}
      >
        {screenSize.large
          ? <BackToTopButton
              caption={p.tc('backToTop')}
              onClick={this.scrollToTop}
            />
          : <SearchButton visible={this.state.displayFromScroll} />}
      </Wrapper>
    )
  }
}

export default withConnect(FixedWidget)
